export default "__VITE_ASSET__BdcDS$qB__"